import _objectSpread from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { ErrorSource, generateUUID, computeRawError, computeStackTrace, Observable, trackRuntimeError, isError, combine } from '@datadog/browser-core';
import { trackConsoleError } from './trackConsoleError';
import { trackReportError } from './trackReportError';
export function startErrorCollection(lifeCycle, configuration) {
  var errorObservable = new Observable();
  trackConsoleError(errorObservable);
  trackRuntimeError(errorObservable);
  trackReportError(configuration, errorObservable);
  errorObservable.subscribe(function (error) {
    return lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
  });
  return doStartErrorCollection(lifeCycle);
}
export function doStartErrorCollection(lifeCycle) {
  lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_ref) {
    var error = _ref.error,
      customerContext = _ref.customerContext;
    customerContext = combine(error.context, customerContext);
    lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, _objectSpread({
      customerContext: customerContext
    }, processError(error)));
  });
  return {
    addError: function addError(_ref2) {
      var error = _ref2.error,
        handlingStack = _ref2.handlingStack,
        componentStack = _ref2.componentStack,
        startClocks = _ref2.startClocks,
        customerContext = _ref2.context;
      var stackTrace = isError(error) ? computeStackTrace(error) : undefined;
      var rawError = computeRawError({
        stackTrace: stackTrace,
        originalError: error,
        handlingStack: handlingStack,
        componentStack: componentStack,
        startClocks: startClocks,
        nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
        source: ErrorSource.CUSTOM,
        handling: "handled" /* ErrorHandling.HANDLED */
      });

      lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
        customerContext: customerContext,
        error: rawError
      });
    }
  };
}
function processError(error) {
  var rawRumEvent = {
    date: error.startClocks.timeStamp,
    error: {
      id: generateUUID(),
      message: error.message,
      source: error.source,
      stack: error.stack,
      handling_stack: error.handlingStack,
      component_stack: error.componentStack,
      type: error.type,
      handling: error.handling,
      causes: error.causes,
      source_type: 'browser',
      fingerprint: error.fingerprint,
      csp: error.csp
    },
    type: "error" /* RumEventType.ERROR */
  };

  var domainContext = {
    error: error.originalError,
    handlingStack: error.handlingStack
  };
  return {
    rawRumEvent: rawRumEvent,
    startTime: error.startClocks.relative,
    domainContext: domainContext
  };
}